module.exports = __webpack_public_path__ + "static/DINNER-16d1e9f709686ea798ff4d970bf108cc.jpg";